import request from '@/utils/request'

let Course_evaluateApi = {

  /*课程评价列表*/
  list(data) {
    return request._post('/shop/plus.course_evaluate.Index/index', data);
},
/*添加课程评价*/
add(data) {
    return request._post('/shop/plus.course_evaluate.Index/add', data);
},
/*修改课程评价*/
edit(data) {
    return request._post('/shop/plus.course_evaluate.Index/edit', data);
},
/*删除课程评价*/
del(data) {
    return request._post('/shop/plus.course_evaluate.Index/del', data);
},
/*课程评价详情*/
detail(data) {
  return request._post('/shop/plus.course_evaluate.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.course_evaluate.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.course_evaluate.Setting/getSetting', data, errorback);
    },
}
export default Course_evaluateApi;



// WEBPACK FOOTER //
// ./src/api/course_evaluate.js